import React from "react";
import VideoDemo from "../../assets/images/videoDemo.png";
import PinkButton from "../../molecules/PinkButton";

const About = () => {
  return (
    <div className="mx-8 mt-10 md:mt-28">
      <div className="text-green text-xl md:text-2xl">lorem, lorem, lorem...</div>
      <div className="text-center md:my-4">
        <img src={VideoDemo} alt="" className=" m-auto py-4" />
        <div className="w-1/2 md:w-1/5 m-auto md:mt-4">
          <PinkButton text="read more" />
          {/* <Link to="/presets">presets</Link> */}
        </div>
      </div>
    </div>
  );
};

export default About;
